import React, { useState, useEffect } from 'react';
import {
  Edit, Create, SimpleForm, TextInput, ReferenceInput,
  AutocompleteInput, DateInput, BooleanInput, Button,
  SelectInput, required, FileInput, FileField
} from 'react-admin';
import * as apiClient from "../../common/apiClient";
import CreateToolbar from "../../common/PopupCreateToolbar";
import {
  useParams
} from "react-router-dom";
import { AgGridReact } from 'ag-grid-react';

import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import AlertDialog from './Dialog';
import { toast } from 'react-toastify';
import { serviceChannelUploadEditColumnDef } from './common';


export const ModuleCreate = props => {

  const defaultValues = {};
  const [isProcessing, setIsProcessing] = useState(false);
  const [error, setError] = useState("");
  const [gridColumns, setGridColumns] = useState<any[]>(serviceChannelUploadEditColumnDef);
  const [result, setResult] = useState<any[]>([]);
  const [da, setDa] = useState<any>(null);
  const [clear, setClear] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const [stats, setStats] = useState<any[]>([]);
  const [displayToolbar, setDisplayToolbar] = useState(true);

  const getDaUploadLogs = () => {
    if (!da.id || da.id == "") return;
    apiClient.getImportUploadLogs(da.id).then(res => {
      setResult(res);
    }).catch(err => {

    });
  }

  const daUploadStats = (id) => {

    apiClient.importUploadStats(id).then(res => {
      console.log(res, "====daUploadStats=====");
      setStats(res);
    }).catch(err => {

    });
  }

  const clearImportUploadLogs = () => {
    if (!da.id || da.id == "") return;
    setIsProcessing(true);
    apiClient.clearImportUploadLogs(da.id).then(res => {
      //console.log(res, "====RES=====");
      getDaUploadLogs();
      setDisplayToolbar(true);
      setIsProcessing(false);
    }).catch(err => {
      setIsProcessing(false);
      toast.error("Error clearing the data");
    });
  }

  const confirmImportUploadLogs = () => {
    if (!da.id || da.id == "") return;
    setIsProcessing(true);
    apiClient.confirmImportUploadLogs(da.id).then(res => {
      //console.log(res, "====RES=====");
      if (res.status == "Success") {
        props.history.push(`/update-ord-servchannels`);
      } else {
        setIsProcessing(false);
        toast.error("Error confirming the data");
      }
    }).catch(err => {
      setIsProcessing(false);
      toast.error("Error confirming the data");
    });
  }

  const handleSubmit = async (formdata) => {

    setError("");
    let isV = 0;
    if (!formdata.importfile) return;
    setIsProcessing(true);
    if (formdata.isVerified) {
      isV = 1;
    }
    let userid: any = localStorage.getItem("userId");

    let d = new Date();
    if (formdata.importDate)
      d = new Date(formdata.importDate);
    let id = "";
    setDisplayToolbar(false);
    if (!da) {
      let daData = {
        importTypeId: 208,
        fileName: formdata.importfile.rawFile.name,
        createdBy: parseInt(userid)
      };
      let daRes = await apiClient.addEntiyRecord("update-ord-servchannels", daData);
      if (!daRes.id) {
        setIsProcessing(false);
        setDisplayToolbar(true);
        return;
      }
      setDa(daRes);
      id = daRes.id;
    } else
      id = da.id;

    apiClient
      .UploadImportFile("importfile", formdata.importfile, id, formdata.importfile.rawFile.name, userid)
      .then((res) => {
        // console.log(res);
        // console.log(res.response);
        if (res.result == "Success") {
          apiClient.getImportUploadLogs(id).then(data => {
            setIsProcessing(false);
            setResult(data);
            daUploadStats(id);
          }).catch(err => {
            console.log(err);
            setIsProcessing(false);
            setDisplayToolbar(true);
          });
        } else {
          let message = res.error;
          setError(message);
        }
      })
      .catch((err) => {
        console.log(err);
        setIsProcessing(false);
        setDisplayToolbar(true);
      });

  }
  const onCancel = () => {
    props.history.goBack();
  }
  useEffect(() => {

  }, []);
  return (
    <><div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
    <a
      href="https://igniteblobstorage.blob.core.windows.net/ignitecontainer/UpdateServiceChannel.csv"
      download
      target="_blank"
      rel="noopener noreferrer"
      style={{
        marginLeft: '8px',
        padding: '6px 12px',
        marginTop: '15px',
        color: 'blue',
        borderRadius: '4px',
        textDecoration: 'none',
        display: 'inline-block',
        cursor: 'pointer'
      }}
    >
      Download Sample CSV
    </a>
  </div>
  
      <Create title="Service Channel File" basePath="importfile" resource="importfile" {...props} undoable={false} >
        <SimpleForm
          onSubmit={handleSubmit}
          toolbar={displayToolbar ? <CreateToolbar saveLabel="Upload File" onSave={handleSubmit} onClose={props.onClose} onCancel={onCancel} /> : null}
          initialValues={defaultValues}
          variant="outlined">

          <FileInput validate={[required()]} source="importfile" label="Document">
            <FileField source="importfile" title="Document" />
          </FileInput>
          
        </SimpleForm>
      </Create>

      {isProcessing && (
        <div className='page-loader-container'>
          <div className='loader'>Loading...</div>
        </div>
      )}
      {<div className='errormessage'>{error}</div>}
      {<div
        className="ag-theme-balham box-shadow"
        style={{
          padding: '0px 24px',
          height: '480px',
          width: '100%'
        }}
      >
        {stats && stats.length > 0 && <div className='stats-parent'>
          {
            stats.map((item) => {
              return (
                <div className='stat-block'>
                  <div className='stat-name'>
                    {item['Name']} : {item['Value']}
                  </div>
                </div>
              )
            })
          }
        </div>}

        <AgGridReact
          columnDefs={gridColumns}
          rowData={result}>
        </AgGridReact>

        {result && result.length > 0 && <div className='upload-actions'>
          {!isProcessing && <Button
            variant="contained" color="primary"
            size="medium"
            label="Confirm Data"
            onClick={() => {
              setConfirm(true);
            }}
          />}
          {!isProcessing && <Button
            variant="contained" color="primary"
            size="medium"
            label="Clear Data"
            onClick={() => {
              setClear(true);
            }}
          />}
          <AlertDialog title="Confirm" message="Are you sure you want to clear the entries?" open={clear} confirm={() => {
            setClear(false);
            clearImportUploadLogs();
          }} cancel={() => {
            setClear(false);
          }} />
          <AlertDialog title="Confirm" message="Are you sure you want to upload the entries?" open={confirm} confirm={() => {
            setConfirm(false);
            confirmImportUploadLogs();
          }} cancel={() => {
            setConfirm(false);
          }} />
        </div>}
      </div>}

    </>
  );
}